<div class="asc-info-container">
  <div class="search-area">
    <div class="search-row">
      <label>スタッフ番号</label>
      <input type="text" 
             [(ngModel)]="userCode" 
             (input)="onUserCodeInput($event)"
             (keydown)="onNumberKeydown($event)"
             (blur)="validateUserCode()"
             maxlength="11" 
             class="user-code-input"
             placeholder="XXX-XX-XXXX"
             autocomplete="off" />
      　OR　
      
      <label>スタッフ番号(Unique)</label>
      <input type="text" 
             [(ngModel)]="ascUq" 
             (input)="onAscUqInput()"
             (keydown)="onNumberKeydown($event)"
             (blur)="validateAscUq()"
             maxlength="9" 
             class="asc-uq-input"
             autocomplete="off" />
      
      <button (click)="onDisplayClick()" class="btn-display">表示</button>
      <button (click)="onClearClick()" class="btn-clear">クリア</button>
    </div>
    
    <div class="error-row" *ngIf="userCodeError || ascUqError">
      <span class="error-message" *ngIf="userCodeError">{{ userCodeError }}</span>
      <span class="error-message" *ngIf="ascUqError">{{ ascUqError }}</span>
    </div>
  </div>

  <div class="error-message" *ngIf="errorMessage && !personal">
    {{ errorMessage }}
  </div>

  <div class="content-area" *ngIf="personal">
    <div class="main-content">
      <!-- 個人データエリア -->
      <div class="personal-data">
        <table class="personal-table">
          <tr>
            <th>氏名</th>
            <td>{{ personal.userName }}</td>
          </tr>
          <tr>
            <th>スタッフ番号</th>
            <td>
              <div style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
                <input type="text" 
                       [(ngModel)]="personalUserCode" 
                       (keydown)="onNumberKeydown($event)"
                       (blur)="validatePersonalUserCode()"
                       maxlength="11" 
                       class="user-code-input"
                       placeholder="XXX-XX-XXXX"
                       autocomplete="off" />
                <span style="white-space:nowrap;">PasswordReset</span>
                <input type="checkbox" [checked]="personal.passwordReset" disabled />
              </div>
              <div class="error-message" *ngIf="personalUserCodeError">{{ personalUserCodeError }}</div>
            </td>
          </tr>
          <tr>
            <th>スタッフ番号(Unique)</th>
            <td>{{ personal.userId }}</td>
          </tr>
          <tr>
            <th>LoginID</th>
            <td>{{ personal.loginId }}</td>
          </tr>
          <tr>
            <th>PBメールアドレス</th>
            <td>{{ personal.email }}</td>
          </tr>
          <tr>
            <th>指定メールアドレス</th>
            <td>
              <input type="text" 
                     [(ngModel)]="email2" 
                     (blur)="validateEmail2()"
                     class="email-input" />
              <span class="error-message" *ngIf="email2Error">{{ email2Error }}</span>
            </td>
          </tr>
          <tr>
            <th>最終ログイン日時</th>
            <td>{{ personal.lastLoginDate ? (personal.lastLoginDate | date:'yyyy/MM/dd HH:mm') : '' }}</td>
          </tr>
          <tr>
            <th>最終リマインド日時</th>
            <td>{{ personal.sendDate ? (personal.sendDate | date:'yyyy/MM/dd HH:mm') : '' }}</td>
          </tr>
          <tr>
            <th>最終更新日</th>
            <td>{{ personal.updateDate ? (personal.updateDate | date:'yyyy/MM/dd HH:mm') : '' }}</td>
          </tr>
        </table>
      </div>

      <!-- 右側エリア（メッセージとボタン） -->
      <div class="right-side">
        <!-- メッセージエリア -->
        <div class="message-area">
          <p>※スタッフ番号はPBで変更した値が翌日反映されます(PB優先)。</p>
          <p>※スタッフ番号を変更すると、LoginIDも変更されます。</p>
          <p>※メールは「指定メールアドレス」に送信されます。リセットすると、PBメールアドレスに戻ります。</p>
        </div>

        <!-- 処理結果メッセージ -->
        <div class="messages">
          <div class="error-message" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>
          <div class="success-message" *ngIf="successMessage">
            {{ successMessage }}
          </div>
        </div>

        <!-- ボタンエリア -->
        <div class="button-area">
          <button class="action-button" (click)="onPasswordResetClick()" [disabled]="!readWrite || adminLevel < 2">パスワードリセット</button>
          <button class="action-button" (click)="onEmailResetClick()" [disabled]="!readWrite || adminLevel < 2">メルアドリセット</button>
          <button class="action-button" [disabled]="!readWrite || !isModifyButtonEnabled || adminLevel < 2" (click)="onModifyClick()">修正</button>
          <button class="action-button" (click)="onReminderClick()" [disabled]="isReminderButtonDisabled">リマインド</button>
        </div>
      </div>
    </div>

    <!-- タイムシートエリア -->
    <div class="timesheet-area">
      <div class="area-header">
        <a *ngIf="!showingPastTimesheets" class="link-disabled">直近のタイムシート</a>
        <a *ngIf="showingPastTimesheets" (click)="onRecentTimesheetsClick()" class="link-active">直近のタイムシート</a>
        
        <a *ngIf="showingPastTimesheets" class="link-disabled">過去のタイムシート</a>
        <a *ngIf="!showingPastTimesheets" (click)="onPastTimesheetsClick()" class="link-active">過去のタイムシート</a>
      </div>
      
      <table class="data-table">
        <thead>
          <tr>
            <th>年月度</th>
            <th>獲注番号</th>
            <th>タイムシートID</th>
            <th>TS番号</th>
            <th>顧客部署番号</th>
            <th>締日</th>
            <th>時間内</th>
            <th>時間外</th>
            <th>深夜</th>
            <th>合計</th>
            <th>未報告</th>
            <th>報告済</th>
            <th>否認</th>
            <th>承認済</th>
            <th>出勤</th>
            <th>欠勤</th>
            <th>有休</th>
            <th>在宅</th>
            <th>残業有</th>
            <th>休日勤務</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ts of timesheets">
            <td>{{ ts.yearMonth }}</td>
            <td><a (click)="onJobOrderClick(ts.jobOrderId)" class="link-text">{{ ts.jobOrderId }}</a></td>
            <td><a (click)="onTimesheetClick(ts)" class="link-text">{{ ts.timesheetId }}</a></td>
            <td class="text-right">{{ ts.timesheetNo }}</td>
            <td><a (click)="onCustomerOfficeClick(ts.customerOfficeId)" class="link-text">{{ ts.customerOfficeCode }}</a></td>
            <td>{{ getCloseDateDisplay(ts.closeDate) }}</td>
            <td>{{ ts.workTime | number:'1.2-2' }}</td>
            <td>{{ ts.overWorkTime | number:'1.2-2' }}</td>
            <td>{{ ts.midnightWorkTime | number:'1.2-2' }}</td>
            <td>{{ ts.total | number:'1.2-2' }}</td>
            <td>{{ ts.editing }}</td>
            <td>{{ ts.submitted }}</td>
            <td>{{ ts.denied }}</td>
            <td class="text-center">{{ ts.approved }}</td>
            <td>{{ ts.attendanceDays }}</td>
            <td>{{ ts.absence }}</td>
            <td>{{ ts.paidHoliday }}</td>
            <td>{{ ts.teleWork }}</td>
            <td>{{ ts.overWorkTime > 0 ? 1 : 0 }}</td>
            <td>{{ ts.midnightWorkTime > 0 ? 1 : 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- コメントエリア -->
    <div class="comment-area">
      <div class="area-header">
        <a *ngIf="!showingPastComments" class="link-disabled">直近のコメント</a>
        <a *ngIf="showingPastComments" (click)="onRecentCommentsClick()" class="link-active">直近のコメント</a>
        
        <a *ngIf="showingPastComments" class="link-disabled">過去のコメント</a>
        <a *ngIf="!showingPastComments" (click)="onPastCommentsClick()" class="link-active">過去のコメント</a>
      </div>
      
      <table class="data-table">
        <thead>
          <tr>
            <th>年月度</th>
            <th>コメント</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let comment of comments">
            <td>{{ comment.yearMonth }}</td>
            <td>{{ comment.comments || '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
